import { Component, OnInit } from '@angular/core';
import { SectionsService } from '../../../_services/sections.service';
import { AppConstants } from '../../../app.constants';

@Component({
	selector: 'app-sky-intro',
	templateUrl: './sky-intro.component.html',
	styleUrls: ['./sky-intro.component.scss']
})
export class SkyIntroComponent implements OnInit {

	public sections;

	constructor( private _sectionsService: SectionsService ) {
		this.sections = AppConstants.sectionInnovation;
		
	}

	ngOnInit() {
		this._sectionsService.setCurrentSectionContent(this.sections);
	}

}
